import { usePostApiTimesheetsByUuidSaveAsync, } from '../../generated/sitComponents';
import { invalidateTimesheetQuery, setTimesheetQueryData } from './query';
export function usePostTimesheetSaveAsync(options) {
    return usePostApiTimesheetsByUuidSaveAsync({
        ...options,
        onSuccess: async (data, variables, onMutateResult, context) => {
            const { id } = variables.pathParams;
            setTimesheetQueryData(context.client, id, (draft) => {
                draft.saveState = 'SAVING';
                return draft;
            });
            await options?.onSuccess?.(data, variables, onMutateResult, context);
        },
        onSettled: async (data, error, variables, onMutateResult, context) => {
            const { id } = variables.pathParams;
            await invalidateTimesheetQuery(context.client, id);
            await options?.onSettled?.(data, error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-timesheet-save.js.map